<template>
	<div class="grey-box">
		<div class="form-horizontal">
			<div class="col-sm-3">
				<img :src="this.$parent.resultVehicle.lLogoUrl" alt="车辆logo" style="height:90px;"/>
				<span>{{this.$parent.resultVehicle.plateNumber}}</span>
			</div>
			<div class="col-sm-3">
				<div class="form-group">
					<label class="col-sm-2 pt5px text-right">车型</label>
					<div class="col-sm-10">
						<input type="text" class="form-control" :value="this.$parent.resultVehicle.modelName" readonly />
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 pt5px text-right">车系</label>
					<div class="col-sm-10">
						<input type="text" class="form-control" :value="this.$parent.resultVehicle.serialName" readonly/>
					</div>
				</div>
			</div>
			<div class="col-sm-3">
				<div class="form-group">
					<label class="col-sm-2 pt5px text-right">颜色</label>
					<div class="col-sm-10">
						<input type="text" class="form-control" :value="this.$parent.resultVehicle.colorName" readonly/>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 pt5px text-right">排量</label>
					<div class="col-sm-10">
						<input type="text" class="form-control" :value="this.$parent.resultVehicle.displacement" readonly/>
					</div>
				</div>
			</div>
			<div class="col-sm-3">
				<div class="form-group">
					<label class="col-sm-2 pt5px text-right">款型</label>
					<div class="col-sm-10">
						<input type="text" class="form-control" :value="this.$parent.resultVehicle.styleName" readonly/>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 pt5px text-right">座位</label>
					<div class="col-sm-10">
						<input type="text" class="form-control" :value="this.$parent.resultVehicle.seatName" readonly/>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-sm-6">
				<div class="pauto5px">
					<div class="ibox float-e-margins">
						<line-l-comp
							:monthInfo = 'monthInfo'
							v-if="showMonComp"
							></line-l-comp>
					</div>
				</div>	
			</div>
			<div class="col-sm-6">
				<div class="pauto5px">
					<div class="ibox float-e-margins">
						<line-r-comp
							:vehicleId='vehicleId'
							v-on:adjustTip='changeTip'
						></line-r-comp>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-sm-6">
				<div class="pauto5px">
					<div class="ibox float-e-margins">
						<bar-comp
						:monthInfo ='monthInfo'
						v-if="showMonComp"
						></bar-comp>
					</div>
				</div>
			</div>
			<div class="col-sm-6">
				<div class="col-sm-6">
					<div class="pauto5px">
						<div class="ibox float-e-margins">
							<pie-on-off
							:dayInfo='dayInfo'
							v-if="showDayComp"
							></pie-on-off>
						</div>
					</div>
				</div>
				<div class="col-sm-6">
					<div class="pauto5px">
						<div class="ibox float-e-margins">
							<pie-run-stop
							:dayInfo='dayInfo'
							v-if="showDayComp"
							></pie-run-stop>
						</div>
					</div>
				</div>	
			</div>
		</div>
	</div>
</template>
<script>
	import { INFO_EMPTY,OPERATE_EXCEPTION } from 'static/message'
	import LineLComp from 'components/modules/carfile/LineLComp'
	import LineRComp from 'components/modules/carfile/LineRComp'
	import BarComp from 'components/modules/carfile/BarComp'
	import PieOnOff from 'components/modules/carfile/PieOnOff'
	import PieRunStop from 'components/modules/carfile/PieRunStop'
	export default{
		name:'DetailHome',
		data(){
			return {
				vehicleId:'',
				monthInfo:[],
				weekInfo:[],
				dayInfo:[],
				showMonComp:false,
				showDayComp:false,
				scrollTop:'',
				dayParam:{
	    			length:30,
	    			stasType:1,
	    			timeType:3,
	    			vehicleId:13
	    		},
	    		monParam:{
	    			length:12,
	    			stasType:0,
	    			timeType:1,
	    			vehicleId:13
	    		}
			}
		},
		components:{
			LineLComp,
			LineRComp,
			BarComp,
			PieRunStop,
			PieOnOff
		},
		beforeMount(){
			this.vehicleId = this.$parent.vehicleInfo.vehicleId;
			this.getDayData()
			this.getMonthData()
		},
		methods:{
			getMonthData(){
				this.monParam.vehicleId = this.vehicleId
				this.$http.get(process.env.API_ROOT + '/vehicle/vehicles/reports/',{params:this.monParam})
			  	.then((response)=>{
			  		if(response.body.success){
			  			if(response.body.data){
			  				this.$set(this,'monthInfo',response.body.data);
			  				this.showMonComp = true;
			  			}else{
			  				this.$parent.openModal(INFO_EMPTY);			
			  			}
			  		}else{
			  			this.$parent.openModal(response.body.message);		
			  		}
			  		this.$parent.loadingstatus += 1;
			  	},(response)=>{
			  		this.$parent.openModal(response.body.message);	
			  		this.$parent.loadingstatus += 1;
			  	})
			  	.catch((response)=>{
			  		this.$parent.openModal(OPERATE_EXCEPTION);	
			  		this.$parent.loadingstatus += 1;
			  	})
			},
			getDayData(){
				this.dayParam.vehicleId = this.vehicleId
				this.$http.get(process.env.API_ROOT + '/vehicle/vehicles/reports/',{params:this.dayParam})
			  	.then((response)=>{
			  		if(response.body.success){
			  			if(response.body.data){
			  				this.$set(this,'dayInfo',response.body.data);
			  				this.showDayComp = true;
			  			}else{
			  				this.$parent.openModal(INFO_EMPTY);	
			  			}
			  		}else{
			  			this.$parent.openModal(response.body.message);	
			  		}
			  		this.$parent.loadingstatus += 1;
			  	},(response)=>{
			  		this.$parent.openModal(response.body.message);	
			  		this.$parent.loadingstatus += 1;
			  	})
			  	.catch((response)=>{
			  		this.$parent.openModal(OPERATE_EXCEPTION);	
			  		this.$parent.loadingstatus += 1;
			  	})
			},
			changeTip(info){//从子组件获取弹框信息
				this.$parent.openModal(info);	
			}
			
		}
	}
</script>


// WEBPACK FOOTER //
// DetailHome.vue?5239df07